import React, { useState } from "react";
import OtpInput from "react-otp-input";
import { useNavigate } from "react-router-dom";

import Swal from "sweetalert2";
import { ApiCall } from "../../../Services/apis";
import PrimaryButton from "../../../components/UI/PrimaryButton";

const Otp = ({ setOtpform, email }) => {
  const navigate = useNavigate();
  const [verification_code, setverification_code] = useState("");
  const handleChange = (verification_code) =>
    setverification_code(verification_code);
  const handleSubmitOtp = async () => {
    try {
      const res = await ApiCall({
        route: `app_api/code_verification`,
        verb: "post",
        params: { verification_code, email },
      });

      if (res?.status == "200") {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "OTP verified  ",
          showConfirmButton: false,
          timer: 3000,
        });
        navigate("/reset-password");
      } else {
        Swal.fire("OTP do not match ", "Try again", "error");
      }
    } catch (e) {
      Swal.fire("invalid OTP  ", "Try again", "error");
    }
  };

  const handleSubmit = async (e) => {
    try {
      const res = await ApiCall({
        route: `app_api/email_verification`,
        verb: "put",
        params: { email: email, role: "patient" },
      });

      if (res?.status == "200") {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "OTP sent",
          showConfirmButton: false,
          timer: 3000,
        });
      } else {
        Swal.fire(res?.response?.message, "Try again", "error");
      }
    } catch (e) {
      Swal.fire("Network Error ", "Try again", "error");
    }
  };

  return (
    <>
      {" "}
      <>
        <div>
          <div className="flex justify-center">
            <div className="w-[80%]">
              <h1 className="text-[#2F2E2E] text-center  md:text-[20px] leading-[64px] font-semibold ">
                Enter OTP
              </h1>
              <h2 className="text-[#2F2E2E] pt-[10px] pb-[5px] text-center text-[14px] leadind-[200%]  ">
                We have sent the OTP to the email addres. Please check your
                email.
              </h2>
              <p style={{ textAlign: "center" }}>{email}</p>
            </div>
          </div>
          <div>
            <form>
              <div className="mb-3 pt-[40px]">
                <div className="flex justify-center">
                  <OtpInput
                    value={verification_code}
                    onChange={handleChange}
                    numInputs={6}
                    separator={<span style={{ width: "8px" }}></span>}
                    isInputNum={true}
                    shouldAutoFocus={true}
                    inputStyle={{
                      border: "2px solid #000",
                      borderRadius: "8px",
                      width: "50px",
                      height: "50px",
                      fontSize: "18px",
                      color: "#000",
                      fontWeight: "400",
                      background: "#ffff",
                      caretColor: "blue",
                    }}
                    focusStyle={{
                      border: "3px solid #002fa7",
                      outline: "none",
                    }}
                  />
                </div>
              </div>
              <div className="flex justify-center mt-[20px] cursor-pointer ">
                <div onClick={() => setOtpform(true)}>
                  {" "}
                  <h2 className="text-sm text-[#002fa7] ">Change Email</h2>{" "}
                </div>
              </div>

              <div className="flex justify-center mt-[10px] cursor-pointer ">
                {" "}
                <h2
                  onClick={(e) => {
                    e.preventDefault();
                    handleSubmit(e);
                    setverification_code(null);
                  }}
                  className="text-sm text-[#002fa7] "
                >
                  Resend OTP
                </h2>{" "}
              </div>

              <div className=" py-8 flex justify-center   ">
                {/* <Link to='/ResetPassword' > */}{" "}
                <PrimaryButton
                  onClick={(e) => {
                    e.preventDefault();
                    handleSubmitOtp({ e, verification_code });
                  }}

                  // className="text-white my-6  bg-[#002fa7]   outline-0  font-medium rounded-xl text-sm px-12 h-[50px] text-center  "
                >
                  Verify OTP
                </PrimaryButton>{" "}
                {/* </Link> */}
              </div>
            </form>
          </div>
        </div>
      </>
    </>
  );
};

export default Otp;
